import React from 'react';
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react';
import { jumpTo } from '@/navigate';
import './index.scss';
import Tips from "../../components/tips";
import BgAudio from "./bgAudio";
import ScrollBar from "../../components/scrollbar";
import scene from '../three/index';

@inject('ScoreStore')
@observer

class App extends React.Component {
    state = {
        unit: 0.1,
        lieType: 0,//0 仰位 1卧位
        jinZhenType: 0,//0 舒张 1 指切 2 提捏 3 夹持 4 单手 5爪切
        thornType: 0,//0 直刺 1 斜刺 2 平刺
        disinfectionType: 0,// 0 手指消毒患者消毒 1 患者消毒手指消毒 
        xzType: 0,//0平补平泻 1提插补泻 2捻转补泻
        xzType_nd: 0,//1提插补法 2提插泻法 3捻转补法 4捻转泻法
        zhenType: 0.5,//13 0.5寸  25 1寸 40 1.5寸 60 2.5寸 75 3寸
        jfType: 0,//0 无需施灸 1温和灸 2 艾炷灸 3 温灸盒灸 4温针灸盒灸 
        optType: 0,
        zhenJiuTime: 1,
        aiJiuTime: 1,
        aiJiuRadio: 0,
        canPlaceYinzhen: false,
        canPlaceAijiu: false,
        placedAijiu: false,
        navDisplay_1: true,
        navDisplay_2: true,
        navDisplay_3: true,

        lineDistVisible:1,
        lineDistSeg:1,
        timeDisplay: false,
        aiJiuTipsDisplay: false,
        posInfo: {},
        zhenIndex: 0,
        zhenIndexType: 0,
        optZhen: [],
        userInput: [],
        stepArr: [],
        xueAudio: "",
        xueTips: false,
        mouseTips: true,
        zhenWeiReady: false,
        restZhen: false,
        stepTips: true

    }

    setUnit(num) {
        this.setState({
            unit: num
        })
    }
    setZhenJiuTime(num) {
        this.setState({
            zhenJiuTime: num
        })
    }
    setAiJiuTime(num) {
        this.setState({
            aiJiuTime: num
        })
    }
    changeLieType(type) {
        this.setState({
            lieType: type
        })
        this.threescene.changeLieType(type);
    }
    closeMouseTips() {
        this.setState({
            mouseTips: false
        })
        this.setXueAudio();
    }
    closeZhenWeiTips() {
        this.setState({
            zhenWeiTips: false
        })
    }
    closeResetZhen() {
        this.setState({
            restZhen: false
        })
    }
    closeStepTips() {
        this.setState({
            stepTips: false
        })
    }
    changeOptType(type) {
        this.setState({
            optType: type
        })
    }
    navDisplay(name) {
        this.setState({
            [name]: !this.state[name]
        })
    }
    timeDisplay() {
        this.setState({
            timeDisplay: true,
            xueAudio: require("../../assets/audio/zhiliaotime.mp3")
        })
    }
    setZhenType(e) {
        this.setState({
            zhenType: e.target.value
        })
        this.refs.scrollbar.reInit();
    }
    setJinZhenType(e) {
        this.setState({
            jinZhenType: e.target.value
        })
    }
    xzChange(e) {
        let value = e.target.value
        let defValue = 0;
        if (value == 1) {
            defValue = 1
        }
        else if (value == 2) {
            defValue = 3
        }
        this.setState({
            xzType: e.target.value,
            xzType_nd: defValue
        })
    }
    xzChange_nd(e) {
        this.setState({
            xzType_nd: e.target.value
        })
    }
    jfChange(e) {
        this.setState({
            jfType: e.target.value
        })
    }
    placeYinzhen() {
        let posInfo = this.state.posInfo;
        let userInput = this.state.userInput;
        let spellName = ""
        if (!this.state.zhenWeiReady) {
            this.setState({
                zhenWeiTips: true
            })
            return false;
        }
        let stepArr = this.state.stepArr;
        if ((this.state.zhenIndexType == 0 && stepArr[this.state.zhenIndex].stepFinish_L) || (this.state.zhenIndexType == 1 && stepArr[this.state.zhenIndex].stepFinish_R)) {
            this.setState({
                restZhen: true
            })
            return false;
        }
        for (let i = 0; i < posInfo.length; i++) {
            if (posInfo[i].posName == userInput[this.state.zhenIndex]) {
                spellName = posInfo[i].spellName;
                break;
            }
        }
        if (this.state.optType == 0) {
            if (this.state.zhenIndexType == 0) {
                this.threescene.placeYinzhen({ zhenType: this.state.zhenType, posName: spellName, thornType: this.state.thornType, unit: this.state.unit });
            }
            else {
                this.threescene.placeYinzhen({ zhenType: this.state.zhenType, posName: spellName + "2", thornType: this.state.thornType, unit: this.state.unit });
            }

        }
        else {
            if (this.state.jfType != 0) {
                this.threescene.placeAijiu({ posName: spellName });
            }
        }
    }
    resetYinzhen() {
        let stepArr = this.state.stepArr;
        stepArr[this.state.zhenIndex].stepFinish = false;
        if (this.state.zhenIndexType == 0) {
            stepArr[this.state.zhenIndex].stepFinish_L = false;
        }
        else {
            stepArr[this.state.zhenIndex].stepFinish_R = false;
        }
        this.setState({
            stepArr,
            restZhen: false
        }, () => {
            this.placeYinzhen();
        })

    }
    changeLineVisible( visible ) {

        this.threescene.distLine.changeVisible( visible );

        this.setState({
            lineDistVisible: visible
        })
    }

    changeThornType(type) {
        this.setState({
            thornType: type
        })
    }
    aiJiuRadioChange(type) {
        this.setState({
            aiJiuRadio: type
        })
    }
    changeStepType() {
        this.setState({
            disinfectionType: this.state.disinfectionType ? 0 : 1
        })
    }

    componentDidMount() {
        let s = scene;
        s.init(this.refs.container, () => {
            s.changeState(0);
        });
        this.threescene = s;
        this.setPosInfo();
        window.Bus.on("zhenweiReady", (score) => {
            this.setState({
                zhenWeiReady: true
            })
        });

        window.Bus.on("yinzhenPlaced", (score) => {
            this.setState({
                zhenWeiReady: false
            })
            this.countScore(score, "zhenjiu")

        });
        window.Bus.on("aijiuPlaced", (score) => {
            this.setState({
                zhenWeiReady: false
            })
            this.countScore(score, "aijiu")

        });
    }
    setPosInfo() {
        let classInfo = this.props.ScoreStore.classInfo;
        let posInfo = toJS(classInfo.posInfo);
        let userInput = toJS(this.props.ScoreStore.userInput);
        let stepShow = [], stepDisable = [];
        posInfo.forEach(e => {
            let index = userInput.indexOf(e.posName);
            if (index != -1) {
                let tempObj = {
                    stepName: e.posName,
                    stepShow: true,
                    stepFinish: false,
                    stepFinish_L: false,
                    stepFinish_R: false,
                }
                stepShow[index] = tempObj;
            }
            else {
                let tempObj = {
                    stepName: e.posName,
                    stepShow: false
                }

                stepDisable.push(tempObj)
            }
        });

        let stepArr = [...stepShow, ...stepDisable]

        this.setState({
            posInfo, userInput, stepArr
        })
    }
    aiJiuScore() {
        // let name = this.state.userInput[this.state.zhenIndex];
        let stepArr = this.state.stepArr
        let index = this.state.zhenIndex
        let getScore = 0, losScore = 0;
        if (this.state.aiJiuRadio == 1) {
            getScore = 1
            // this.props.ScoreStore.addScore(1);
        }
        else {
            losScore = 1
            // this.props.ScoreStore.setPenalties(name + "艾灸阶段", 1);
        }
        if (this.state.jfType == 3) {
            getScore = getScore + 1
            // this.props.ScoreStore.addScore(1);
        }
        else {
            losScore = losScore + 1
            // this.props.ScoreStore.setPenalties(name + "艾灸阶段", 1);
        }
        stepArr[index].getScore = stepArr[index].getScore + getScore;
        stepArr[index].losScore = stepArr[index].losScore + losScore;
        this.setState({
            stepArr: stepArr,
            aiJiuTipsDisplay: false
        }, () => {
            this.setXueFinishAudio()
        })
    }
    countScore(score, type) {
        let posInfo = this.state.posInfo;
        let userInput = this.state.userInput;
        let getScore = 0, losScore = 0;
        for (let i = 0; i < posInfo.length; i++) {
            if (posInfo[i].posName == userInput[this.state.zhenIndex]) {
                let scoreUnit = 0.25, scoreTotal = 1.75;
                if (posInfo[i].posName == "神阙") {
                    scoreTotal = 3.5;
                    scoreUnit = 0.5
                }
                if (score.dist <= 1) {
                    losScore = scoreTotal - scoreUnit * 7;
                    getScore = scoreUnit * 7
                    // this.props.ScoreStore.addScore(scoreUnit * 7);
                }
                else if (score.dist > 1 && score.dist <= 4.9) {
                    losScore = scoreTotal - scoreUnit * 3;
                    getScore = scoreUnit * 3
                    // this.props.ScoreStore.addScore(scoreUnit * 3);
                }
                else if (score.dist > 4.9 && score.dist <= 10) {
                    losScore = scoreTotal - scoreUnit;
                    getScore = scoreUnit
                    // this.props.ScoreStore.addScore(scoreUnit);
                }
                else {
                    losScore = scoreTotal
                    getScore = 0
                }

                if (posInfo[i].aiJiuFlag && type == "aijiu") {
                    // this.props.ScoreStore.setPenalties(posInfo[i].posName + "艾灸阶段", scoreTotal);
                    this.setState({
                        aiJiuTipsDisplay: true,
                        xueAudio: require("../../assets/audio/shijiutips.mp3")
                    })
                }
                else {
                    if (!posInfo[i].aiJiuFlag) {
                        // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreTotal);
                        if (this.state.lieType == posInfo[i].lieType) {
                            getScore = getScore + scoreUnit
                            // this.props.ScoreStore.addScore(scoreUnit);
                        }
                        else {
                            losScore = losScore + scoreUnit
                            // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit);
                        }
                        if (this.state.disinfectionType == posInfo[i].disinfectionType) {
                            getScore = getScore + scoreUnit
                            // this.props.ScoreStore.addScore(scoreUnit);
                        }
                        else {
                            losScore = losScore + scoreUnit
                            // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit);
                        }
                        if (this.state.jinZhenType == posInfo[i].jinZhenType) {
                            getScore = getScore + scoreUnit * 4
                            // this.props.ScoreStore.addScore(scoreUnit * 4);
                        }
                        else {
                            losScore = losScore + scoreUnit * 4
                            // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit * 4);
                        }
                        if (this.state.thornType == posInfo[i].thornType) {
                            getScore = getScore + scoreUnit * 2
                            // this.props.ScoreStore.addScore(scoreUnit * 2);
                        }
                        else {
                            losScore = losScore + scoreUnit * 2
                            // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit * 2);
                        }
                        if (this.state.xzType == posInfo[i].xzType) {
                            if (posInfo[i].xzType_nd != 0) {
                                getScore = getScore + scoreUnit * 2
                                // this.props.ScoreStore.addScore(scoreUnit * 2);
                            }
                            else {
                                getScore = getScore + scoreUnit * 4
                                // this.props.ScoreStore.addScore(scoreUnit * 4);
                            }

                        }
                        else {
                            if (posInfo[i].xzType_nd != 0) {
                                losScore = losScore + scoreUnit * 2
                                // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit * 2);
                            }
                            else {
                                losScore = losScore + scoreUnit * 4
                                // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit * 4);
                            }

                        }
                        if (posInfo[i].xzType_nd != 0) {
                            if (this.state.xzType_nd == posInfo[i].xzType_nd) {
                                getScore = getScore + scoreUnit * 2
                            }
                            else {
                                losScore = losScore + scoreUnit * 2
                            }

                        }
                        if (this.state.zhenType == posInfo[i].zhenType) {
                            getScore = getScore + scoreUnit
                            // this.props.ScoreStore.addScore(scoreUnit);
                        }
                        else {
                            losScore = losScore + scoreUnit
                            // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit);
                        }
                        if (this.state.unit >= posInfo[i].unitInterval[0] && this.state.unit <= posInfo[i].unitInterval[1]) {
                            getScore = getScore + scoreUnit * 2
                            // this.props.ScoreStore.addScore(scoreUnit * 2);
                        }
                        else {
                            losScore = losScore + scoreUnit * 2
                            // this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", scoreUnit * 2);
                        }
                    }
                    else {
                        losScore = losScore + 2
                        // this.props.ScoreStore.setPenalties(posInfo[i].posName + "艾灸阶段", scoreTotal);
                        // this.props.ScoreStore.setPenalties(posInfo[i].posName + "艾灸阶段", 2);
                    }

                }
                break;
            }

        }

        let stepArr = this.state.stepArr;
        let index = this.state.zhenIndex;
        if (userInput[index] == "神阙") {
            stepArr[index].stepFinish = true;
            stepArr[index].stepFinish_L = true;
            stepArr[index].stepFinish_R = true;
            stepArr[index].getScore = getScore;
            stepArr[index].losScore = losScore;
        }
        else {
            if (this.state.zhenIndexType == 0) {
                stepArr[index].stepFinish_L = true;
                stepArr[index].getScore_L = getScore;
                stepArr[index].losScore_L = losScore;
            }
            else {
                stepArr[index].stepFinish_R = true;
                stepArr[index].getScore_R = getScore;
                stepArr[index].losScore_R = losScore;
            }
            if (stepArr[index].stepFinish_L && stepArr[index].stepFinish_R) {
                stepArr[index].stepFinish = true;
            }
        }
        this.setState({
            stepArr: stepArr
        }, () => {
            if (stepArr[index].stepFinish && !this.state.aiJiuTipsDisplay) {
                this.setXueFinishAudio();
            }
        })

    }
    setXueAudio() {
        let posInfo = this.state.posInfo;
        let userInput = this.state.userInput;
        for (let i = 0; i < posInfo.length; i++) {
            if (posInfo[i].posName == userInput[this.state.zhenIndex]) {
                this.setState({
                    xueAudio: posInfo[i].audio,
                    xueTips: true
                }, () => {
                    clearTimeout(this.Timmer);
                    this.Timmer = setTimeout(() => {
                        this.setState({
                            xueTips: false
                        })
                    }, 5000)
                })
                break;
            }
        }
    }
    setXueFinishAudio() {
        this.setState({
            xueAudio: require("../../assets/audio/xuefinish.mp3")
        })
    }
    componentWillUnmount() {
        this.threescene.deinit();
    }
    nextStep() {
        let posInfo = this.state.posInfo;
        let stepArr = this.state.stepArr;
        let finishInput = [];
        stepArr.forEach((e) => {
            if (e.stepShow) {
                if (!e.stepFinish) {
                    for (let i = 0; i < posInfo.length; i++) {
                        if (e.stepName == posInfo[i].posName) {
                            if (posInfo[i].aiJiuFlag) {
                                this.props.ScoreStore.setPenalties(e.stepName + "艾灸阶段", posInfo[i].totalScore);
                            }
                            else {
                                if (!e.stepFinish_L && !e.stepFinish_R) {
                                    this.props.ScoreStore.setPenalties(e.stepName + "针刺阶段", posInfo[i].totalScore);
                                }
                                else {
                                    if (e.stepFinish_L) {
                                        finishInput.push(e.stepName)
                                        this.props.ScoreStore.addScore(e.getScore_L)
                                        if (e.losScore_L > 0) {
                                            this.props.ScoreStore.setPenalties(e.stepName + "针刺阶段", e.losScore_L);
                                        }
                                    }
                                    if (e.stepFinish_R) {
                                        finishInput.push(e.stepName + "2")
                                        this.props.ScoreStore.addScore(e.getScore_R)
                                        if (e.losScore_R > 0) {
                                            this.props.ScoreStore.setPenalties(e.stepName + "针刺阶段", e.losScore_R);
                                        }
                                    }
                                    this.props.ScoreStore.setPenalties(e.stepName + "针刺阶段", posInfo[i].totalScore / 2);
                                }

                            }
                            break;
                        }
                    }
                }
                else {
                    if (e.stepName == "神阙") {
                        finishInput.push(e.stepName);
                        this.props.ScoreStore.addScore(e.getScore)
                        if (e.losScore > 0) {
                            this.props.ScoreStore.setPenalties(e.stepName + "艾灸阶段", e.losScore);
                        }
                    }
                    else {
                        this.props.ScoreStore.addScore(e.getScore_L + e.getScore_R);
                        if (e.losScore_L + e.losScore_R > 0) {
                            this.props.ScoreStore.setPenalties(e.stepName + "针刺阶段", e.losScore_L + e.losScore_R);
                        }
                        finishInput.push(e.stepName);
                        finishInput.push(e.stepName + "2");
                    }

                }
            }
            else {
                for (let i = 0; i < posInfo.length; i++) {
                    if (e.stepName == posInfo[i].posName) {
                        if (posInfo[i].aiJiuFlag) {
                            this.props.ScoreStore.setPenalties(posInfo[i].posName + "艾灸阶段", posInfo[i].totalScore);
                        }
                        else {
                            this.props.ScoreStore.setPenalties(posInfo[i].posName + "针刺阶段", posInfo[i].totalScore);
                        }
                        break;
                    }
                }
            }
        })
        this.props.ScoreStore.setInput(finishInput);
        if (this.state.zhenJiuTime >= 20 && this.state.zhenJiuTime <= 30) {
            this.props.ScoreStore.addScore(0.5);
        }
        else {
            this.props.ScoreStore.setPenalties("治疗时间", 0.5);
        }
        if (this.state.aiJiuTime >= 20 && this.state.aiJiuTime <= 30) {
            this.props.ScoreStore.addScore(0.5);
        }
        else {
            this.props.ScoreStore.setPenalties("治疗时间", 0.5);
        }

        jumpTo("guide6")
    }
    skipStep(step, stepType) {
        this.setState({
            zhenIndex: step,
            zhenIndexType: stepType
        }, () => {
            this.setXueAudio();
        })
    }
    stepFinish() {

        this.threescene.distLine.changeVisible(0);
        this.timeDisplay();
    }

    stepShowRender() {
        let stepArr = this.state.stepArr;
        if (stepArr.length > 0) {
            let item = stepArr.map((item, index) => {
                return (<div key={index} className={`zhen_step_item ${item.stepShow == false ? "disable" : ""} ${index == this.state.zhenIndex ? "active" : ""}`}>
                    {index == this.state.zhenIndex ? <div className={"step_circle_icon"} onClick={() => { if (item.stepShow) { this.skipStep(index, 0) } }}>{item.stepFinish ? <img src={require("../../assets/images/icon_finish.png")} /> : index + 1}</div> : <div className={"step_circle_icon"} onClick={() => { if (item.stepShow) { this.skipStep(index, 0) } }}>{item.stepFinish ? <img src={require("../../assets/images/icon_finish_blue.png")} /> : index + 1}</div>}
                    <div className={"step_name_view"}>
                        <div className={item.stepFinish ? "finish" : ""}>{item.stepName}</div>
                        {item.stepName != "神阙" && item.stepShow && <div className={"name_btn"}>
                            <button className={`${item.stepFinish_L ? "finish" : ""} ${index == this.state.zhenIndex && this.state.zhenIndexType == 0 ? "active" : ""}`} onClick={() => { if (item.stepShow) { this.skipStep(index, 0) } }}>左</button><button onClick={() => { if (item.stepShow) { this.skipStep(index, 1) } }} className={`${item.stepFinish_R ? "finish" : ""} ${index == this.state.zhenIndex && this.state.zhenIndexType == 1 ? "active" : ""}`}>右</button>
                        </div>}
                    </div>
                </div>)
            })
            return (<div className="zhen_step_list">
                {item}
            </div>)
        }

    }
    render() {
        return (
            <div className="page page-guide guide_room_4">
                <div className="threescene" ref="container"></div>
                <div className="room_name">治疗室</div>
                <div className="step_pos_view">
                    {this.stepShowRender()}
                    <div className="step_finish_btn"><button onClick={() => { this.stepFinish() }}>完成</button></div>
                    <div className={`step_pos_tips ${this.state.stepTips ? "" : "hide"}`}>
                        <i className="icon_close" onClick={() => { this.closeStepTips() }}></i>
                        <div>请在穴位提纲选择要执行的针灸的穴位</div>
                        <div className="tips_btn">
                            <button onClick={() => { this.closeStepTips() }}>我知道了</button>
                        </div>
                    </div>
                </div>
                <div className={`reset_zhen_tips ${this.state.restZhen ? "open" : ""}`}>
                    <div className="reset_tips">对该穴位重新操作？</div>
                    <div className="reset_btn"><button onClick={() => { this.closeResetZhen() }}>取消</button><button onClick={() => {
                        this.resetYinzhen()
                    }}>确定</button></div>
                </div>
                <div className="opt_step_view">

                    <div className={`opt_step_item ${this.state.navDisplay_3 ? "" : "close"}`}>
                        <div className={`step_arrow ${this.state.navDisplay_3 ? "" : "arrow_left"}`} onClick={() => { this.navDisplay("navDisplay_3") }}></div>
                       
                         <div className="item_from">
                            <label>标尺设置</label>
                            <div className="from_view view_flex">
                                <div className={`from_radio ${this.state.lineDistVisible == 1 ? "active" : ""}`} onClick={() => { this.changeLineVisible(1) }}>显示</div>
                                <div className={`from_radio ${this.state.lineDistVisible == 0 ? "active" : ""}`} onClick={() => { this.changeLineVisible(0) }}>隐藏</div>
                            </div>

                            <div className="from_view view_flex">
                                <div className="line-seg">
                                    <span className="label">段数</span>
                                    <div  className="line-seg-input">
                                         <input type="number" value={this.state.lineDistSeg} onChange={(e)=>{
                                            this.setState({
                                                lineDistSeg: e.target.value
                                            });
                                    }}/>
                                    </div>
                                    
                                    <button className="form_btn" onClick={() => {
                                        this.threescene.distLine.updateLineSeg(this.state.lineDistSeg);    
                                    }}>更新</button>
                                </div>
                               
                             </div>

                             <div className="from_view line-seg"><button className="form_btn" onClick={() => {
                                this.threescene.distLine.clear();     
                            }}>清除</button></div>
                        </div>
                    </div>
                    
                    <div className={`opt_step_item ${this.state.navDisplay_1 ? "" : "close"}`}>
                        <div className={`step_arrow ${this.state.navDisplay_1 ? "" : "arrow_left"}`} onClick={() => { this.navDisplay("navDisplay_1") }}></div>
                        <div className="item_from">
                            <label>体位选择</label>
                            <div className="from_view view_flex">
                                <div className={`from_radio ${this.state.lieType == 0 ? "active" : ""}`} onClick={() => { this.changeLieType(0) }}>仰卧位</div>
                                <div className={`from_radio ${this.state.lieType == 1 ? "active" : ""}`} onClick={() => { this.changeLieType(1) }}>俯卧位</div>
                            </div>
                        </div>
                    </div>
                    
                    <div className={`opt_step_item ${this.state.navDisplay_2 ? "" : "close"}`}>
                        <div className={`step_arrow ${this.state.navDisplay_2 ? "" : "arrow_left"}`} onClick={() => { this.navDisplay("navDisplay_2") }}></div>
                        <div className="item_from">
                            <div className="from_view view_flex">
                                <div className={`from_radio ${this.state.optType == 0 ? "active" : ""}`} onClick={() => { this.changeOptType(0) }}>针刺方案</div>
                                <div className={`from_radio ${this.state.optType == 1 ? "active" : ""}`} onClick={() => { this.changeOptType(1) }}>艾灸方案</div>
                            </div>
                        </div>
                        {this.state.optType == 0 ? <div className="opt_view">
                            <div className="item_from">
                                <label>消毒选择</label>
                                <div className="from_view">
                                    <div className="item_step_view">
                                        <span>第一步</span>
                                        <span>{this.state.disinfectionType ? "患者皮肤消毒" : "操作者手指消毒"}</span>
                                    </div>
                                    <div className="change_view"><i className="icon_change" onClick={() => { this.changeStepType() }}></i></div>
                                    <div className="item_step_view">
                                        <span>第二步</span>
                                        <span>{this.state.disinfectionType ? "操作者手指消毒" : "患者皮肤消毒"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="item_from">
                                <label>针具选择</label>
                                <div className="from_view">
                                    <select onChange={(e) => { this.setZhenType(e) }}>
                                        <option value={0.5}>13x0.25mm （0.5寸）</option>
                                        <option value={1}>25x0.3mm（1寸）</option>
                                        <option value={1.5}>40x0.3mm（1.5寸）</option>
                                        <option value={2.5}>60x0.3mm（2.5寸）</option>
                                        <option value={3}>75x0.35mm（3寸）</option>
                                    </select>
                                </div>
                            </div>
                            <div className="item_from">
                                <label>进针手法</label>
                                <div className="from_view">
                                    <select onChange={(e) => { this.setJinZhenType(e) }}>
                                        <option value={0}>舒张进针法</option>
                                        <option value={1}>指切进针法</option>
                                        <option value={2}>提捏进针法</option>
                                        <option value={3}>夹持进针法</option>
                                        <option value={4}>单手进针法</option>
                                    </select>
                                </div>
                            </div>
                            <div className="item_from">
                                <label>进针角度</label>
                                <div className="from_view view_flex">
                                    <div className={`from_radio radio_s ${this.state.thornType == 0 ? "active" : ""}`} onClick={() => { this.changeThornType(0) }}>直刺</div>
                                    <div className={`from_radio radio_s ${this.state.thornType == 1 ? "active" : ""}`} onClick={() => { this.changeThornType(1) }}>斜刺</div>
                                    <div className={`from_radio radio_s ${this.state.thornType == 2 ? "active" : ""}`} onClick={() => { this.changeThornType(2) }}>平刺</div>
                                </div>
                            </div>
                            <div className="item_from">
                                <label>进针深度</label>
                                <div className="from_view scroll_view">
                                    <div className="scroll_bar"><ScrollBar ref="scrollbar" floatUnit={1} minnum={0.1} maxnum={this.state.zhenType} callBack={(num) => { this.setUnit(num) }} /></div>
                                    <div className="unit">{this.state.unit}寸</div>
                                </div>
                            </div>
                            <div className="item_from">
                                <label>行针手法</label>
                                <div className="from_view">
                                    <select onChange={(e) => { this.xzChange(e) }}>
                                        <option value={0}>平补平泻</option>
                                        <option value={1}>提插补泻</option>
                                        <option value={2}>捻转补泻</option>
                                    </select>
                                </div>
                                {this.state.xzType == 1 && <div className="from_view">
                                    <select onChange={(e) => { this.xzChange_nd(e) }}>
                                        <option value={1}>提插补法</option>
                                        <option value={2}>提插泻法</option>
                                    </select>
                                </div>}
                                {this.state.xzType == 2 && <div className="from_view">
                                    <select onChange={(e) => { this.xzChange_nd(e) }}>
                                        <option value={3}>捻转补法</option>
                                        <option value={4}>捻转泻法</option>
                                    </select>
                                </div>}
                            </div>
                        </div> : <div className="opt_view"><div className="item_from">
                            <label>灸法选择</label>
                            <div className="from_view"><select onChange={(e) => { this.jfChange(e) }}>
                                <option value={0}>无需施灸</option>
                                <option value={1}>温和灸</option>
                                <option value={2}>艾炷灸</option>
                                <option value={3}>温灸盒灸</option>
                                <option value={4}>温针灸盒灸</option>
                            </select></div>
                        </div></div>}
                        <div className="item_from_btn">
                            <button onClick={() => {
                                this.placeYinzhen();
                            }}>确定</button>
                        </div>
                    </div>
                </div>

                <div className={`pos_name_tips ${this.state.xueTips ? "" : "hide"}`}>现在进入{this.state.userInput[this.state.zhenIndex]}穴操作阶段</div>
                <div className={`form_view ${this.state.timeDisplay ? "" : "hide"}`}>
                    <div className="form_tit tit_l">选择治疗时间</div>
                    <div className="form_bd">
                        <div className="form_time">
                            <label>留针时间</label>
                            <div className="scroll_bar"><ScrollBar minnum={1} maxnum={40} callBack={(num) => { this.setZhenJiuTime(num) }} /></div>
                            <div className="time">{this.state.zhenJiuTime}分钟</div>
                        </div>
                        <div className="form_time">
                            <label>艾灸时间</label>
                            <div className="scroll_bar"><ScrollBar minnum={1} maxnum={40} callBack={(num) => { this.setAiJiuTime(num) }} /></div>
                            <div className="time">{this.state.aiJiuTime}分钟</div>
                        </div>
                    </div>
                    <div className="form_btn">
                        <button onClick={() => { this.nextStep() }}>确定</button>
                    </div>
                </div>
                <div className={`form_view ${this.state.aiJiuTipsDisplay ? "" : "hide"}`}>
                    <div className="form_tit no_line">施灸时应该注意什么?</div>
                    <div className="form_bd">
                        <div className={`form_radio ${this.state.aiJiuRadio == 0 && "active"}`} onClick={() => { this.aiJiuRadioChange(0) }}>
                            <i className="icon_radio"></i><span>注意保暖</span>
                        </div>
                        <div className={`form_radio ${this.state.aiJiuRadio == 1 && "active"}`} onClick={() => { this.aiJiuRadioChange(1) }}>
                            <i className="icon_radio"></i><span>询问患者温度</span>
                        </div>
                    </div>
                    <div className="form_btn" >
                        <button onClick={() => { this.aiJiuScore() }}>确定</button>
                    </div>
                </div>
                <div className={`mouse_tips_cover ${this.state.mouseTips ? "" : "hide"}`}>
                    <div className="mouse_tips_view">
                        <i className="icon_close" onClick={() => { this.closeMouseTips() }}></i>
                        <div><img src={require("../../assets/images/mouse_tips.png")} /></div>
                        <div className="tips_btn">
                            <button onClick={() => { this.closeMouseTips() }}>我知道了</button>
                        </div>
                    </div>
                </div>

                {this.state.zhenWeiTips && <div className="zhenwei_tips">
                    <i className="tips_close" onClick={() => { this.closeZhenWeiTips() }}></i>
                    <ul>
                        <li>第一步：请在虚拟人体上使用鼠标左键，红点标记相应穴位位置。</li>
                        <li>第二步：完成穴位标记后在画面右侧选择针灸方案。</li>
                        <li>第三步：根据不同穴位制定相应针灸方案，并点击确定执行方案。</li>
                    </ul>
                </div>}
                <audio src={this.state.xueAudio} autoPlay={true} />
                <Tips init={false} studyTips={2} />
                <BgAudio />
            </div>
        );
    }
}

export default App;
